import { render, staticRenderFns } from "./myNeeds.vue?vue&type=template&id=bcf1e534&scoped=true&"
import script from "./myNeeds.vue?vue&type=script&lang=js&"
export * from "./myNeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf1e534",
  null
  
)

export default component.exports